// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__XhimK","fade-in":"Content_fade-in__AYDPf"};